// src/theme/ThemeContext.js
import { createContext } from "react";
import { createTheme, } from "@mui/material/styles";

// Import palettes
import lightPalette from "./palettes/lightPalette";
import darkPalette from "./palettes/darkPalette";
import typography from "./typography";

// Import component styles
import cardStyles from "./components/cardStyles";
import buttonStyles from "./components/buttonStyles";
import cardActionsStyles from "./components/cardActionsStyles";
import cardHeaderStyles from "./components/cardHeaderStyles.js";
import paperStyles from "./components/paperStyles";
import tabStyles from "./components/tabStyles";
import formStyles from "./components/formStyles";
import iconButtonStyles from "./components/iconButtonStyles";

// Create responsive components function
const createResponsiveComponents = (theme) => ({
  ...cardStyles(theme),
  ...buttonStyles(theme),
  ...cardActionsStyles(theme),
  ...cardHeaderStyles(theme),
  ...paperStyles(theme),
  ...tabStyles(theme),
  ...formStyles(theme),
  ...iconButtonStyles(theme),
});

// Create base theme function
export const createBaseTheme = (mode) => {
  const palette = mode === "dark" ? darkPalette : lightPalette;

  // First create a base theme to access in the component creation
  const baseTheme = createTheme({
    palette,
    typography,
    // Add breakpoints for better mobile handling
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  });

  // Now create the complete theme with components that can access the base theme
  const completeTheme = createTheme({
    ...baseTheme,
    components: createResponsiveComponents(baseTheme),
  });

  console.log("Complete Theme:", completeTheme); // Debugging: Log the complete theme

  return completeTheme;
};

// Create and export the theme context
const ThemeContext = createContext({
  theme: createBaseTheme("light"),
  toggleTheme: () => {},
  isMobile: false,
});

export default ThemeContext;
